import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { Pagination, Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

const StarofYearList = () => {
  const [posts, setPosts] = useState({ starofyear: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ id: null, status: "" });
  const [showToast, setShowToast] = useState(false);

  const navigate = useNavigate();
  const usernameRef = useRef(null);

  const role = localStorage.getItem("userrole");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mypip = searchParams.get("mypip");
  const id = localStorage.getItem("employeeid");

  let paginate = 0;
  let buttonClass = "";
  let rejectBtnClass = "";
  let indexOfLastPost = 0;
  let indexOfFirstPost = 0;
  let currentPosts = null;

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        let url = `${baseURL}/getemployeestarofyearhnominations`;
        const { data } = await axios(url);
        console.log("Fetched data:", data);
        if (Array.isArray(data.starofyear)) {
          setPosts({ starofyear: data.starofyear });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const getNominations = async () => {
    try {
      let url = `${baseURL}/getemployeestarofyearhnominations`;
      const { data } = await axios(url);
      console.log("Fetched data:", data);
      if (Array.isArray(data.starofyear)) {
        setPosts({ starofyear: data.starofyear });
      } else {
        console.error("Data is not an array:", data);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };
  const handleHRStatus = async (nid, status) => {
    try {
      const response = await axios.get(
        `${baseURL}/hrstarofyearofupdate?nid=${nid}&status=${status}&hr=${id}`
      );
      if (response.status === 200) {
        setShowToast(true);

        setTimeout(() => {
          setShowToast(false);
          getNominations();
          navigate("/startofyearlist"); // Replace '/another-page' with your desired path
        }, 3000);
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleView = (nominationid) => {
    window.location.href = "/startofyear?awid=" + nominationid;
  };

  const handleClose = () => {
    setSelectedIssue(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = () => {
    handleHRStatus(modalData.id, modalData.status);
    setShowModal(false);
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  paginate = (pageNumber) => setCurrentPage(pageNumber);

  indexOfLastPost = currentPage * postsPerPage;
  indexOfFirstPost = indexOfLastPost - postsPerPage;
  currentPosts = posts.starofyear.slice(indexOfFirstPost, indexOfLastPost);

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">Star Of the Year</h4>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Employee Id</th>
            <th>Employee Name</th>
            <th>Nominator Name</th>
            <th>Award Month</th>
            <th>Date Requested</th>
            <th>View Form</th>
            <th>HR Status</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts != null &&
            currentPosts.map((employee, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{employee.employeeid}</td>
                <td>
                  {employee.employee_firstname} {employee.employee_lastname}
                </td>
                <td>
                  {employee.recommended_by_firstname}{" "}
                  {employee.recommended_by_lastname}
                </td>
                <td>{employee.month_year}</td>
                <td>{formatDate(employee.createdat)}</td>
                <td className="d-flex justify-content-center align-items-center">
                  <ReactBootstrap.Button
                    className="badge bg-secondary border-0"
                    onClick={() => handleView(employee.id)}
                  >
                    View
                  </ReactBootstrap.Button>
                </td>
                <td>
                  <div className="d-none">
                    {
                      (buttonClass =
                        employee.hrapproval === "Approved"
                          ? "badge bg-warning ml-1 text-dark border-0"
                          : "badge bg-success ml-1 border-0")
                    }
                  </div>
                  <div className="d-none">
                    {
                      (rejectBtnClass =
                        employee.hrapproval === "Rejected"
                          ? "badge bg-danger ml-1 border-0"
                          : "badge bg-danger ml-1 border-0")
                    }
                  </div>
                  <div>
                    <button
                      className={buttonClass}
                      type="button"
                      value="Approve"
                      disabled={employee.hrapproval === "Approved"}
                      onClick={() => {
                        setShowModal(true);
                        setModalData({ id: employee.id, status: "Approved" });
                      }}
                    >
                      {employee.hrapproval === "Approved"
                        ? "Approved"
                        : "Approve"}
                    </button>
                    <button
                      className={rejectBtnClass}
                      type="button"
                      value="Reject"
                      disabled={employee.hrapproval === "Rejected"}
                      onClick={() => {
                        setShowModal(true);
                        setModalData({ id: employee.id, status: "Rejected" });
                      }}
                    >
                      {employee.hrapproval === "Rejected"
                        ? "Rejected"
                        : "Reject"}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </ReactBootstrap.Table>

      <Pagination>
        {Array.from(
          { length: Math.ceil(posts.starofyear.length / postsPerPage) },
          (_, index) => (
            <Pagination.Item key={index} onClick={() => paginate(index + 1)}>
              {index + 1}
            </Pagination.Item>
          )
        )}
      </Pagination>

      <div>
        <ToastContainer position="top-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to confirm the changes?</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirmSubmit}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StarofYearList;
